import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=050daf2f&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=js&"
export * from "./NoData.vue?vue&type=script&lang=js&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=050daf2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050daf2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050daf2f')) {
      api.createRecord('050daf2f', component.options)
    } else {
      api.reload('050daf2f', component.options)
    }
    module.hot.accept("./NoData.vue?vue&type=template&id=050daf2f&scoped=true&", function () {
      api.rerender('050daf2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NoData/NoData.vue"
export default component.exports